import { useAuth0 } from '@auth0/auth0-react';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Snowfall from 'react-snowfall';

const SnowFall = ({ isPlaying }) => {
  const { isAuthenticated } = useAuth0();
  const location = useLocation();
  const homePage = location?.pathname === '/';
  const shortBannerCondition = isAuthenticated || (!isAuthenticated && !homePage);
  const valueOfSnowFlakeCount = shortBannerCondition ? 50 : 70;
  const [snowflakeCount, setSnowflakeCount] = useState(isPlaying ? valueOfSnowFlakeCount : 0);

  useEffect(() => {
    if (isPlaying) {
      setSnowflakeCount(valueOfSnowFlakeCount);
    } else {
      const timer = setTimeout(() => {
        setSnowflakeCount(0);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isPlaying]);

  return (
    <Snowfall
      color='#fff'
      snowflakeCount={snowflakeCount}
      speed={shortBannerCondition ? [0, 0.5] : [0.25, 1.5]}
      style={{
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        opacity: isPlaying ? 1 : 0,
        transition: 'opacity 1s ease-out',
      }}
    />
  );
};

export default SnowFall;
